import { Classroom } from '@/api/classroom'

const state = () => ({
    preTest: [],
    postTest: [],
    preTestItems: [],
    postTestItems: [],
    preTestItem: null,
    postTestItem: null,
    loadingClassroomTest: false,
    isSuccessClassroomTest: false,
    messageClassroomTest: '',
    createdPreTest: {}, 
    createdPostTest: {}, 
})

const getters = {
    preTest: state => state.preTest,
    postTest: state => state.postTest,
    preTestItems: state => state.preTestItems,
    postTestItems: state => state.postTestItems,
    preTestItem: state => state.preTestItem,
    postTestItem: state => state.postTestItem,
    loadingClassroomTest: state => state.loadingClassroomTest,
    isSuccessClassroomTest: state => state.isSuccessClassroomTest,
    messageClassroomTest: state => state.messageClassroomTest,
    createdPreTest: state => state.createdPreTest, 
    createdPostTest: state => state.createdPostTest, 
}

const actions = {
    async fetchPreTest({commit}, id) {
        await Classroom.getPreTest(id)
        .then(res => {
            commit('setPreTest', res.data.data)
        })
        .catch(err => {
            commit('setPreTest', null)
            commit('setMessageClassroomTest', err)
            commit('setIsSuccessClassroomTest', false)
        })
    },
    async fetchPostTest({commit}, id) {
        await Classroom.getPostTest(id)
        .then(res => {
            commit('setPostTest', res.data.data)
        })
        .catch(err => {
            commit('setPostTest', null)
            commit('setMessageClassroomTest', err)
            commit('setIsSuccessClassroomTest', false)
        })
    },
    async createPreTest({commit}, data) {
        commit('setLoadingClassroomTest', true)
        await Classroom.addPreTest(data)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Menambahkan Pre-Test')
                commit('setCreatedPreTest', res.data.data)
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setLoadingClassroomTest', false)
            commit('setIsSuccessClassroomTest', false)
            commit('setMessageClassroomTest', err)
        })
    },
    async createPostTest({commit}, data) {
        commit('setLoadingClassroomTest', true)
        await Classroom.addPostTest(data)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Menambahkan Post-Test')
                commit('setCreatedPostTest', res.data.data)
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setLoadingClassroomTest', false)
            commit('setIsSuccessClassroomTest', false)
            if( err.errors.length > 0 ) {
                commit('setMessageClassroomTest', err.errors[0].message)
            } else {
                commit('setMessageClassroomTest', err)
            }
        })
    },
    async editPreTest({commit}, data) {
        const id = data.id
        const payload = data.payload
        commit('setLoadingClassroomTest', true)
        await Classroom.updatePreTest(id, payload)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Mengubah Pre-Test')
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setLoadingClassroomTest', false)
            commit('setIsSuccessClassroomTest', false)
            commit('setMessageClassroomTest', err)
        })
    },
    async editPostTest({commit}, data) {
        const id = data.id
        const payload = data.payload
        commit('setLoadingClassroomTest', true)
        await Classroom.updatePostTest(id, payload)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Mengubah Pre-Test')
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setLoadingClassroomTest', false)
            commit('setIsSuccessClassroomTest', false)
            commit('setMessageClassroomTest', err)
        })
    },
    async removePrePostTest({commit}, data) {
        const id = data.id
        const type = data.type
        if(type) {
            commit('setLoadingClassroomTest', true)
            await Classroom.deletePostTest(id)
            .then(res => {
                commit('setLoadingClassroomTest', false)
                if(res.data.success) {
                    commit('setIsSuccessClassroomTest', true)
                    commit('setMessageClassroomTest', 'Berhasil Menghapus Post-Test')
                } else {
                    commit('setIsSuccessClassroomTest', false)
                    commit('setMessageClassroomTest', 'Terjadi Kesalahan')
                }
            })
            .catch(err => {
                commit('setLoadingClassroomTest', false)
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', err)
            })
        } else {
            commit('setLoadingClassroomTest', true)
            await Classroom.deletePreTest(id)
            .then(res => {
                commit('setLoadingClassroomTest', false)
                if(res.data.success) {
                    commit('setIsSuccessClassroomTest', true)
                    commit('setMessageClassroomTest', 'Berhasil Menghapus Pre-Test')
                } else {
                    commit('setIsSuccessClassroomTest', false)
                    commit('setMessageClassroomTest', 'Terjadi Kesalahan')
                }
            })
            .catch(err => {
                commit('setLoadingClassroomTest', false)
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', err)
            })
        }
    },

    async createPrePostTestItem({commit}, data) {
        const type = data.type
        const payload = data.payload
        commit('setLoadingClassroomTest', true)
        await Classroom.addPrePostTestItem(payload, type)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Menambahkan Soal')
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan')
            }
        })
        .catch(err => {
            commit('setLoadingClassroomTest', false)
            commit('setIsSuccessClassroomTest', false)
            commit('setMessageClassroomTest', err)
        })
    },

    async editPrePostTestItem({commit}, data) {
        const id = data.id
        const payload = data.payload
        const type = data.type
        commit('setLoadingClassroomTest', true)
        await Classroom.updatePrePostTestItem(id, payload, type)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Mengubah Soal')
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan Mengubah Soal')
            }
        })
        .catch(err => {
            commit('setMessageClassroomTest', err)
            commit('setIsSuccessClassroomTest', false)
            commit('setLoadingClassroomTest', false)
        })
    },

    async removePrePostTestItem({commit}, payload) {
        const id = payload.id
        const type = payload.type
        commit('setLoadingClassroomTest', true)
        await Classroom.deletePrePostTestItem(id, type)
        .then(res => {
            commit('setLoadingClassroomTest', false)
            if(res.data.success) {
                commit('setIsSuccessClassroomTest', true)
                commit('setMessageClassroomTest', 'Berhasil Menghapus Soal')
            } else {
                commit('setIsSuccessClassroomTest', false)
                commit('setMessageClassroomTest', 'Terjadi Kesalahan Menghapus Soal')
            }
            
        })
        .catch(err => {
            commit('setMessageClassroomTest', err)
            commit('setIsSuccessClassroomTest', false)
            commit('setLoadingClassroomTest', false)
        })
    }
}

const mutations = {
    setPreTest: (state, preTest) => {
        state.preTest = preTest
    },
    setPostTest: (state, postTest) => {
        state.postTest = postTest
    },
    setPreTestItems: (state, items) => {
        state.preTestItems = items
    },
    setPostTestItems: (state, items) => {
        state.postTestItems = items
    },
    setPreTestItem: (state, item) => {
        state.preTestItem = item
    },
    setPostTestItem: (state, item) => {
        state.postTestItem = item
    },
    setLoadingClassroomTest: (state, loading) => {
        state.loadingClassroomTest = loading
    },
    setIsSuccessClassroomTest: (state, success) => {
        state.isSuccessClassroomTest = success
    },
    setMessageClassroomTest: (state, message) => {
        state.messageClassroomTest = message
    },
    setCreatedPreTest: (state, created) => {
        state.createdPreTest = created
    },
    setCreatedPostTest: (state, created) => {
        state.createdPostTest = created
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}